import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function ProspectNameForm({ prospectFirstName, prospectLastName, changeValue }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Name:</Form.Label>
      </Col>
      <Col md={2} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="firstName"
          id="firstName"
          placeholder="First name"
          value={prospectFirstName || ''}
          onChange={changeValue}
        />
      </Col>
      <Col md={2} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="lastName"
          id="lastName"
          placeholder="Last name"
          value={prospectLastName || ''}
          onChange={changeValue}
        />
      </Col>
    </>
  );
}

export default memo(ProspectNameForm);
